import Brands from './Brands/Brands'
import Projects from './Projects/Projects'
import { Row, Col, Container } from 'reactstrap'

function Home() {
  return (
    <main className="Home">
      <Container>
        <Row tag={'section'} className="justify-content-center">
          <Col sm="8">
            <article className="py-5">
              <h1 className="font-weight-bold">Front-End Developer</h1>
              <p>
                Especialista em front-end e mobile (React, React Native,
                TypeScript, PWAs, acessibilidade) — foco em performance,
                conversão e experiência consistente.
              </p>
            </article>
            <Projects />
          </Col>
          <Col sm="12">
            <Brands />
          </Col>
        </Row>
      </Container>
    </main>
  )
}

export default Home
